import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import TranslationKeys from 'src/constants/translation-keys';
import { IconInformationFillSmall } from '@amzn/stencil-react-icons';
import { recordEvent } from 'src/analytics/amplify'
import { RouterLink } from '../RouterLink';
import { Button, ButtonVariant } from '@amzn/stencil-react-components/button';
import { LinkTextDecorationOptions } from '@amzn/stencil-react-components/dist/submodules/link/interfaces';
import { token } from '@amzn/stencil-design-tokens/js/web/utils';

export default function PrivacyFlyout() {
    const { t } = useTranslation();

    useEffect(() => {
        recordEvent({
            name: 'PrivacyFlyout.Render',
            immediate: true
        });
    }, []);

    return (
        <RouterLink textDecoration={LinkTextDecorationOptions.None}
                data-testid="privacy-flyout-button"
                to='/privacy-policy'
                style={{textDecoration: 'none'}}>
            <Button variant={ButtonVariant.TertiaryInline}
                    as="span"
                    style={{color: token('color.link.primary-default')}}
                    icon={<IconInformationFillSmall aria-hidden={true} />}
                    data-testid="footer-text-privacy">
                {t(TranslationKeys.FOOTER.PRIVACY_POLICY)}
            </Button>
        </RouterLink>
    );
}
